module.exports = __webpack_public_path__ + "img/pngwing-brown (16).3b7b1b67.png";